////    CORE    ////
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import { map, Observable, of } from 'rxjs'

@Injectable({
  providedIn: 'root',
})
export class AuthGuard {

  constructor(private router: Router) { }
  
  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (localStorage.getItem('token')) {
      return true
    } else {
      this.router.navigate(['login']).then(() => {
        window.location.reload();
      })
      return false
    }
  }
}
